import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  actions: {},
  getters: {
    [getters.GET_APP_PAGES]: state => state.pages,
    [getters.GET_APP_SNACKBAR]: state => state.snackbar,
    [getters.GET_APP_TOAST]: state => state.toast,
  },
  mutations: {
    [mutations.SET_APP_SNACKBAR](state, snackbar) {
      snackbar.queued_at = new Date();
      state.snackbar = snackbar;
    },
    [mutations.SET_APP_TOAST](state, toast) {
      state.toast = toast;
    },
  },
  state: {
    pages: [
      'account',
      'media',
      'events',
      'users',
      'church',
      'articles',
    ],
    snackbar: {},
    toast: {},
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/app.js